import { Box, Typography, Chip } from '@mui/material'
import { IconChevronRight } from '@tabler/icons-react'
import styled from 'styled-components'

// Main container for the tab content
export const SavedMenusContainer = styled(Box).attrs(() => {
  return {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      paddingBottom: '24px',
    },
  }
})(() => ({}))

// Card container - horizontal layout
export const MenuCardContainer = styled(Box).attrs(() => {
  return {
    sx: {
      display: 'flex',
      gap: '12px',
      padding: '12px',
      borderRadius: '12px',
      border: '1px solid',
      borderColor: 'grey.200',
      backgroundColor: 'background.paper',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      '&:hover': {
        borderColor: 'grey.300',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.08)',
      },
      '&:active': {
        backgroundColor: 'grey.50',
      },
      alignItems: 'flex-start',
      minHeight: '120px',
    },
  }
})(() => ({}))

// Thumbnail/placeholder area
export const MenuThumbnailContainer = styled(Box).attrs(() => {
  return {
    sx: {
      flexShrink: 0,
      width: '96px',
      height: '96px',
      borderRadius: '8px',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'grey.100',
    },
  }
})(() => ({}))

// Placeholder tile (when no image)
export const MenuPlaceholderTile = styled(Box).attrs(() => {
  return {
    sx: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #FFF5ED 0%, #FFE8D4 100%)',
      gap: '4px',
    },
  }
})(() => ({}))

// Menu image
export const MenuImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

// Main content area
export const MenuContentContainer = styled(Box).attrs(() => {
  return {
    sx: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: '8px',
      minWidth: 0,
    },
  }
})(() => ({}))

// Menu name
export const MenuNameTypography = styled(Typography).attrs(() => {
  return {
    variant: 'body2',
    sx: {
      fontWeight: 600,
      color: 'text.primary',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  }
})(() => ({}))

// Restaurant name
export const RestaurantNameTypography = styled(Typography).attrs(() => {
  return {
    variant: 'caption',
    sx: {
      color: 'text.secondary',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  }
})(() => ({}))

// Meta row container (dish count, saved date)
export const MetaRowContainer = styled(Box).attrs(() => {
  return {
    sx: {
      display: 'flex',
      gap: '12px',
      alignItems: 'center',
      flexWrap: 'wrap',
      fontSize: '12px',
      color: 'text.secondary',
    },
  }
})(() => ({}))

// Meta text
export const MetaText = styled(Typography).attrs(() => {
  return {
    variant: 'caption',
    sx: {
      color: 'text.secondary',
    },
  }
})(() => ({}))

// Type chip (User Provided / Scan Only)
export const TypeChip = styled(Chip).attrs(({ theme }) => {
  return {
    size: 'small',
    sx: {
      height: '20px',
      fontSize: '11px',
      fontWeight: 500,
      backgroundColor: 'primary.50',
      color: 'primary.main',
      '& .MuiChip-label': {
        padding: '0 6px',
      },
    },
  }
})(() => ({}))

// Sample dishes container (pills/chips)
export const DishesRowContainer = styled(Box).attrs(() => {
  return {
    sx: {
      display: 'flex',
      gap: '6px',
      flexWrap: 'wrap',
    },
  }
})(() => ({}))

// Dish pill
export const DishPill = styled(Chip).attrs(() => {
  return {
    size: 'small',
    variant: 'outlined',
    sx: {
      height: '20px',
      fontSize: '11px',
      borderColor: 'grey.300',
      color: 'text.secondary',
      backgroundColor: 'grey.50',
      '& .MuiChip-label': {
        padding: '0 6px',
        textTransform: 'capitalize',
      },
    },
  }
})(() => ({}))

// Right side chevron affordance
export const ChevronContainer = styled(Box).attrs(() => {
  return {
    sx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      color: 'grey.400',
    },
  }
})(() => ({}))

export const ChevronIcon = styled(IconChevronRight).attrs(() => {
  return {
    size: 20,
    stroke: 2,
  }
})(() => ({}))
